import React from "react";

import { useTranslation } from "react-i18next";

import Checkbox from "../../../Form/Checkbox";
import { ColumnWrapper, ColumnTitle } from "./styles";

type Column = {
  title: string;
  columnName: string;
  spacingColumns?: string;
};

interface Props {
  checkColumn?: boolean;
  isOnViewMode?: boolean;
  columns: Column[];
  isAllRowsSelected?: boolean;
  isActionColumnOnEnd?: boolean;
  onSelectAll?: (checked: boolean) => void;
}

export const UIColumn = ({
  checkColumn = true,
  isOnViewMode = false,
  columns,
  isAllRowsSelected,
  isActionColumnOnEnd = true,
  onSelectAll,
}: Props) => {
  const { t: translate } = useTranslation();

  return (
    <ColumnWrapper
      checkColumn={checkColumn}
      isOnViewMode={isOnViewMode}
      spacingColumns={columns.map((column) => column.spacingColumns).join(" ")}
    >
      {checkColumn && (
        <div>
          <Checkbox
            label=""
            checked={isAllRowsSelected}
            onChange={(_, checked) => onSelectAll && onSelectAll(checked)}
          />
        </div>
      )}
      {columns?.map((column, index: number) => (
        <div key={index}>
          <ColumnTitle>{column.title}</ColumnTitle>
        </div>
      ))}
      {!isOnViewMode && (
        <div className={`${isActionColumnOnEnd && "text-right"}`}>
          <ColumnTitle>{translate("action")}</ColumnTitle>
        </div>
      )}
    </ColumnWrapper>
  );
};
